export * from './TeamAvatar.types';
export { default as TeamAvatar } from './TeamAvatar';
